import React from 'react';
import { TagIcon } from '@heroicons/react/24/outline';

interface RemisionesMetricsProps {
  totalRemisiones: number;
  productoId: string;
  isLoading: boolean;
}

const RemisionesMetrics: React.FC<RemisionesMetricsProps> = ({ 
  totalRemisiones, 
  productoId, 
  isLoading 
}) => {
  if (isLoading) {
    return (
      <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
        <div className="animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-1/4 mb-2"></div>
          <div className="h-8 bg-gray-200 rounded w-1/2"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <TagIcon className="h-5 w-5 text-blue-600" />
            <span className="text-sm font-medium text-gray-700">SKU:</span>
            <span className="text-sm font-mono bg-gray-100 px-2 py-1 rounded">
              {productoId}
            </span>
          </div>
        </div>
        
        <div className="flex items-center space-x-2">
         {/*  <DocumentTextIcon className="h-5 w-5 text-green-600" /> */}
         {/*  <span className="text-sm font-medium text-gray-700">Total Remisiones:</span>
          <span className="text-lg font-bold text-green-600">
            {totalRemisiones.toLocaleString()}
          </span> */}
        </div>
      </div>
    </div>
  );
};

export default RemisionesMetrics;
